export const CssVariables = {
    headerHeight: '3.5rem',
    licenseWarningHeight: '2rem',

    masterDetailsAsideWidth: '31rem',
};

export const CssColors = {
    black: '#1d1d1f',
    mainGreen: '#3FE579',
    secondaryGreen: '#9CE4A3',
    mainRed: '#F33F4A',
    mainGray: '#9B9BA4',
    inputBorderColor: '#D2D2D7',
    mainYellow: '#E3DB40',
};
